<template>
  <div class="message">
    <el-popover v-model="visible" popper-class="message-poper" placement="bottom" width="343" trigger="click">
      <div slot="reference">
        <el-badge class="red" :hidden="!count" is-dot>
          <i class="el-icon-message-solid" />
        </el-badge>
        <span class="txt">系统通知</span>
      </div>
      <div class="message-content">
        <div class="top">
          <el-tabs v-model="activeTab" @tab-click="getData">
            <el-tab-pane label="通知" name="local" />
          </el-tabs>
        </div>
        <div v-loading="loading" class="content">
          <template v-if="list.length">
            <div v-for="(item,index) in list" :key="index" class="item">
              <div class="lt">
                <el-badge :hidden="item.hasRead === 2" is-dot />
                <div class="tip" @click="detail(item)">{{ item.content }}</div>
              </div>
              <div class="rt">{{ item.createdAt }}</div>
            </div>
          </template>
          <div v-else class="no-message">暂无系统消息~</div>
        </div>
        <div class="btm">
          <div class="lt">
            <el-button v-if="readShow" size="mini" type="text" :loading="readLoading" @click="allRead">全部已读</el-button>
          </div>
          <div class="rt" @click="goToList">
            <span class="jump">查看历史消息</span>
            <span class="icon el-icon-arrow-right" />
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { getNews, isRead, allRead } from './../../api/data'
import { mapGetters } from 'vuex'
// import {get_msg_list, read_all_msg, get_msg_summary} from '@/api/public'
export default {
  name: 'Message',
  data() {
    return {
      loading: false,
      visible: false,
      count: 0,
      list: [],
      userId: '',
      show: false,
      readLoading: false,
      readShow: false,
      activeTab: 'local'
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  watch: {
    visible(val) {
      if (!val) return
      this.loading = true
      this.getCount()
    }
  },
  created() {
    this.getData()
    this.loopGetData()
  },
  beforeDestroy() {
    this.$notify.closeAll()
  },
  methods: {
    async getData() {
      this.readShow = false
      this.loading = true
      if (this.user.userId) {
        this.userId = this.user.userId
        const res = await getNews(this.userId)
        this.list = res.data.data
        this.count = res.data.TotalHasRead
        this.loading = false
      }
      this.loading = false
      // get_msg_list({
      //   page: 1,
      //   platform: this.activeTab
      // }).then(res => {
      //   this.list = res.data.list;

      //   this.loading = false
      if (this.count > 0) {
        this.readShow = true
      }
      // }).catch(err => {
      //   this.loading = false;
      // });
    },
    getCount() {
      this.getData()
    },
    loopGetData() {
      if (this.visible) return
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getNewMsg()
      }, 300000)
      this.$once('hook:beforeDestroy', () => {
        clearInterval(this.timer)
      })
    },
    goToList() {
      this.$router.push({
        path: '/message',
        query: {
          type: this.activeTab
        }
      })
      this.visible = false
    },
    detail(item) {
      if (item.hasRead !== 2) {
        isRead(item.id).then(res => {
          if (res.code === 200) {
            this.getData()
          }
        })
      }
      if (item.type === 1) {
        this.$router.push({
          path: '/punctuation/myClient'
        })
      }
      if (item.type === 2) {
        this.$router.push({ name: 'ContractFormDetail', query: { id: item.objectId }, params: { id: item.objectId }})
      }
      if (item.type === 3) {
        this.$router.push({
          path: '/punctuation/list'
        })
      }
      // let page = {
      //   path: '/message/info',
      //   query: {
      //     id: item.id
      //   }
      // }
      // this.toPage(page)
      // this.visible = false;
    },
    toPage(data) {
      const url = this.$router.resolve(data)
      window.open(url.href)
    },
    allRead() {
      this.readLoading = true
      allRead(this.user.userId).then(res => {
        this.loading = true
        this.readLoading = false
        this.getCount()
        this.$message.success('操作成功')
      })
      // read_all_msg({
      //   platform: this.activeTab
      // }).then(res => {
      //   this.loading = true;
      //   this.readLoading = false;
      //   this.getCount();
      //   this.$message.success('操作成功')
      // }).catch(() => {
      //   this.readLoading = false;
      // })
    },
    getNewMsg() {
      // get_msg_summary().then(res => {
      //   const {total, new: msgInfo} = res.data
      //   if (total != 0) {
      //     this.showNotify(total, msgInfo)
      //   }
      // })
    },
    showNotify(count, info) {
      let message = ''
      let jumpData = {}
      if (count > 1) {
        message = `
          <p style="width: 280px;">提醒，您有${count}条消息待查看~</p>
        `
        jumpData = {
          path: '/message/list'
        }
      } else {
        message = `
          <p >【${info.type_word}】</p>
          <p class="overflow-2-row" style="width: 280px;">${info.content}</p>
        `
        jumpData = {
          path: '/message/info',
          query: {
            id: info.id
          }
        }
      }
      message += `<br><button style="float: right;" type="button" class="el-button el-button--primary is-plain el-button--small">
        点击查看
      </button>`
      this.$notify.closeAll()
      this.$notify({
        dangerouslyUseHTMLString: true,
        message,
        offset: 55,
        duration: 0,
        onClick: () => {
          this.$router.push(jumpData)
          this.$notify.closeAll()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  cursor: pointer;
  margin-right: 25px;
  color: #a3a6ae;
  font-size: 14px;
}
.red {
  ::v-deep .is-fixed{
    transform: none
  }
  ::v-deep .is-dot{
    left: -2px;
    top: 30%
  }
}
.message-content {
  .top {

    .top-content{
      display: flex;
      align-items: center;
    }
    .txt {
      font-size: 14px;
      color: #606266;
      font-weight: 700;
    }

    .num {
      font-size: 12px;
      color: #FF5541;
    }
  }

  .content {
    max-height: 300px;
    overflow: auto;
    margin: 0 -12px;
    padding: 0 11px 21px 11px;
    background-color: #F8F8F8;
    border-top: 1px solid #EEEEEE;

    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 21px;
      cursor: pointer;

      .lt {
        display: flex;
        align-items: center;
        margin-right: 20px;

        ::v-deep.is-dot {
          top: 50%;
          margin-right: 5px;
        }

        .tip {
          color: #606266;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      .rt {
        color: #ACB0B9;
        font-size: 12px;
        flex-shrink: 0;
      }

      &:hover {
        .tip {
          color: #3C6CF5;
        }
      }
    }

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 20px;
      background-color: #f2f2f2;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 20px;
      background-color: #C2C2C2;
    }
  }

  .btm {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 14px;
    color: #606266;
    font-size: 12px;
    cursor: pointer;

    .jump {
      margin-right: 5px;
    }
  }

  .no-message {
    color: #606266;
    font-size: 14px;
    text-align: center;
    padding: 50px 0 29px;
  }
}
</style>
